import React, { Component } from 'react';
import logo from '../assets/AHTT_logo.gif';
import Logo from './Landing/Logo';

class Subscribed extends Component {
    render() {
        return (
            <div className="content">
                <div id="newsletter-thanks">
                    <h1>Almost finished!</h1>
                    <p>We need to confirm your email address.</p>
                    <p>To complete the newsletter subscription process, please click the link in the email we just sent you.</p>
                    <img src={logo} className="landing-logo" alt="logo" />
                </div>
                <Logo />
            </div>
        );
    }
}

export default Subscribed;



// WEBPACK FOOTER //
// ./src/components/Subscribed.js